



















import { FeedStateModule } from '@/store';
import { TagModel } from '@/type/api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TopicsService } from '@/kuroco_api';
import truncate from 'lodash/truncate';
import { PostFileHelper, util } from '@/util';

@Component<CreateFeedContainerFilePreview>({})
export default class CreateFeedContainerFilePreview extends Vue {
  // PROPS
  @Prop({
    type: Object,
    required: false,
  })
  source!: InstanceType<typeof PostFileHelper>['renderSource'][0];
  @Prop({
    type: Object,
    required: true,
  })
  helper!: PostFileHelper;
  @Prop({
    type: Object,
    required: false,
  })
  additionalStyle?: object;
  @Prop({
    type: Boolean,
    required: true,
  })
  vimeo!: boolean;

  // FIELDS
  ELEMENT_TYPE = ELEMENT_TYPE;

  // MUTATIONS
  get elmType() {
    if (!this.source) {
      return ELEMENT_TYPE.NONE;
    }
    switch (this.helper.mediaType) {
      case 'image':
        return ELEMENT_TYPE.IMAGE;
      case 'video':
        return this.vimeo ? ELEMENT_TYPE.VIDEO_VIMEO : ELEMENT_TYPE.VIDEO;
    }
  }
}

enum ELEMENT_TYPE {
  NONE,
  IMAGE,
  VIDEO_VIMEO,
  VIDEO,
}
